import { CountryObj } from './types';

export function mapAndSortCountries(
  countryCodes: string[] | undefined,
  countryDetails: CountryObj[]
): CountryObj[] {
  const countriesInfo: CountryObj[] = [];
  if (countryCodes) {
    countryCodes.map((countryCode) => {
      if (countryCode && countryDetails[countryCode]) {
        countriesInfo.push(countryDetails[countryCode]);
      }
    });
  }
  return countriesInfo
    ? countriesInfo.sort((a, b) => a.name.localeCompare(b.name))
    : countriesInfo;
}

export function langSpecificEnums(data: any, enumsObj: any) {
  return data.map((d: any) => {
    const enumItem = enumsObj[d.name];
    if (enumItem) {
      const items = d.items.map((di: any) => {
        const enumvalueItem = enumItem[di.value];
        if (enumvalueItem) {
          di = { ...di, description: enumvalueItem };
        }
        return di;
      });
      d = { ...d, items };
    }
    return d;
  });
}